import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 border-t border-gray-800">
      <div className="container mx-auto px-4 py-8">
        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} BiteSizR. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="/terms-and-conditions.html" className="text-gray-400 hover:text-white transition-colors text-sm">
              Terms
            </a>
            <a href="/privacypolicy.html" className="text-gray-400 hover:text-white transition-colors text-sm">
              Privacy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;